import { Send } from "lucide-react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";
import { api, fetchCollection, formatApiError } from "@/lib/api";

const STATUS_LABEL = { published: "publicado", error: "error", skipped: "omitido" };

export function useSocialStatus() {
  return useQuery({ queryKey: ["social-status"], queryFn: () => fetchCollection("/social/status"), staleTime: 300000 });
}

export function SocialPublishField({ checked, onChange, editing }) {
  const { data } = useSocialStatus();
  const queryClient = useQueryClient();
  const publish = useMutation({
    mutationFn: async () => (await api.post(`/admin/chronicles/${editing.id}/publish-social`)).data,
    onSuccess: (result) => {
      const ok = Object.values(result).filter((item) => item.status === "published").length;
      (ok ? toast.success : toast.error)(ok ? `Publicado en ${ok} red${ok > 1 ? "es" : ""}` : Object.values(result).map((item) => item.error).filter(Boolean).join(" · ") || "No se pudo publicar");
      queryClient.invalidateQueries({ queryKey: ["chronicles"] });
    },
    onError: (error) => toast.error(formatApiError(error)),
  });
  const enabled = Boolean(data?.enabled);
  const social = editing?.social;

  return (
    <div className="grid gap-3 border border-white/10 bg-white/[0.02] p-4" data-testid="admin-chronicle-social-field">
      <span className="field-label">Facebook e Instagram de TODOtiro</span>
      {!enabled ? (
        <p className="text-xs text-slate-500" data-testid="admin-chronicle-social-disabled">La publicación automática se activará cuando se configuren las credenciales de Meta. Mientras tanto, usa «Copiar enlace» para compartir la crónica.</p>
      ) : editing ? (
        <div className="flex flex-wrap items-center gap-4">
          <p className="text-xs text-slate-400" data-testid="admin-chronicle-social-state">
            {social ? Object.entries(social).map(([network, item]) => `${network}: ${STATUS_LABEL[item.status] || item.status}${item.error ? ` (${item.error})` : ""}`).join(" · ") : "Todavía no publicada en redes"}
          </p>
          <Button type="button" variant="outline" onClick={() => publish.mutate()} disabled={publish.isPending} className="rounded-none border-clay/40 bg-clay/10 font-mono text-[10px] uppercase tracking-[0.2em] text-clay hover:bg-clay hover:text-charcoal" data-testid="admin-chronicle-social-publish-button">
            {publish.isPending ? "Publicando..." : "Publicar ahora en redes"} <Send className="h-3 w-3" />
          </Button>
        </div>
      ) : (
        <label className="flex cursor-pointer items-center gap-3 text-sm text-slate-200">
          <input type="checkbox" checked={checked} onChange={(event) => onChange(event.target.checked)} className="h-4 w-4 accent-[#ff6b00]" data-testid="admin-chronicle-social-checkbox" />
          Publicar automáticamente la foto principal y el resumen de redes al guardar
        </label>
      )}
    </div>
  );
}
